/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutCompletedRegionController', function ($scope, $q, $element, CommonUtils) {

            $scope.Step = 'Completed';
            $scope.Config = {};

            Cookies.set("ForceClearCartLocalStorage", 1, { samesite: 'Lax' });
            Cookies.remove('returning_customer', { path: '/' });
            Cookies.set("ForceClearDeliveryPointLocalStorage", 1, { samesite: 'Lax' });
            localStorage.removeItem('CurrentUserModel');

            clearAffiliatesCookies();

            var controls = [];
            $scope.registerControl = function (name, control) {
                if ($scope[name] === undefined) {
                    $scope[name] = {
                        Wrapper: control,
                        Current: undefined
                    };
                    controls.push(control);
                }
            };
            $scope.setControlValue = function (name, value) {
                if ($scope[name] === undefined)
                    throw new Error(name + ' is not registered as a control on the shared $scope');

                $scope[name].Current = value;
            };

            angular.element(".checkout-completed-region").ready(function () {
                if ($(".checkout-loading").length > 0) {
                    $(".checkout-loading").hide();
                }
            });   

            if (checkoutOverrides && checkoutOverrides.Completion && typeof checkoutOverrides.Completion.IniteSatisfaction === 'function') {
                angular.element(".x-checkoutorder").ready(function () {
                    checkoutOverrides.Completion.IniteSatisfaction($scope, $q);
                });
            }

        });
})();